

const AgenceReducer = (state, action) => {
    switch (action.type) {
        case "GET_AGENCE_START":
            return {
                ...state,
                agences: [],
                isFetching: true,
                error: false,
            };
        case "GET_AGENCES_SUCCESS":
            return {
                ...state,
                agences: action.payload.agences,
                count: action.payload.count,
                isFetching: false,
                error: false,
            };
        case "GET_AGENCES_FAILURE":
            return {
                ...state,
                agences: [],
                isFetching: false,
                error: action.payload,
            };
        case "ADD_AGENCE_START":
            return {
                ...state,
                agence: {},
                isFetchingAdd: true,
                errorAdd: false,
            };
        case "ADD_AGENCE_SUCCESS":
            return {
                ...state,
                agence: action.payload.agence,
                isFetchingAdd: false,
                errorAdd: false,
            };
        case "ADD_AGENCE_FAILURE":
            return {
                ...state,
                agence: {},
                isFetchingAdd: false,
                errorAdd: action.payload,
            };
        case "UPDATE_AGENCE_START":
            return {
                ...state,
                agence: {},
                isFetchingUpdate: true,
                errorUpdate: false,
            };
        case "UPDATE_AGENCE_SUCCESS":
            return {
                ...state,
                agence: action.payload.agence,
                isFetchingUpdate: false,
                errorUpdate: false,
            };
        case "UPDATE_AGENCE_FAILURE":
            return {
                ...state,
                agence: {},
                isFetchingUpdate: false,
                errorUpdate: action.payload,
            };
        case "GET_AGENCES_BY_WILAYA_SUCCESS":
            return {
                ...state,
                agencesByWilaya: action.payload.agences,
            };
        default:
            return { ...state };
    }
}

export default AgenceReducer;